import ActiveFilterPanel from "containers/ActiveFilterPanel";
import ToggleFilterPanel from "containers/ToggleFilterPanel";
import CascadeFilter from "containers/CascadeFilter";
import FilterGroup from "containers/FilterGroup";
import KeywordTriggeredBanner from "containers/KeywordTriggeredBanner";
import OptionFilter from "containers/OptionFilter";
import Result from "containers/Result";
import ResultFeedback from "containers/ResultFeedback";
import SearchBar from "containers/SearchBar";

export function getRegistrationMap() {
  const registration = new Map();
  const namespace = "SAL.";

  registration.set(namespace + "ActiveFilters", ActiveFilterPanel);
  registration.set(namespace + "ToggleFilterPanel", ToggleFilterPanel);
  registration.set(namespace + "CascadeFilter", CascadeFilter);
  registration.set(namespace + "FilterGroup", FilterGroup);
  registration.set(
    namespace + "KeywordTriggeredBanner",
    KeywordTriggeredBanner,
  );
  registration.set(namespace + "OptionFilter", OptionFilter);
  registration.set(namespace + "Result", Result);
  registration.set(namespace + "SearchBar", SearchBar);
  registration.set(namespace + "SearchResultFeedback", ResultFeedback);

  return registration;
}
